import client from './../sanity/sanityClient';

const lang = sessionStorage.getItem('langue') || 'fr';

export const fetchHero = async () => {
  const query = `*[_type == "Tourisme"]{
    heroSection[]{
      "textePrincipal": textePrincipal.${lang},
      "texteSecondaire": texteSecondaire.${lang},
      "description": description.${lang},
      imageFond{
        asset->{
          _id,
          url
        }
      }
    }
  }[0]`;

  try {
    const data = await client.fetch(query);
    return data.heroSection;
  } catch (error) {
    console.error('Error fetching hero section:', error);
    return null;
  }
};

export const fetchServices = async () => {
  const query = `*[_type == "Tourisme"]{
    servicesPage{
      serviceBlocks[]{
        style,
        image{
          asset->{
            _id,
            url
          }
        },
        icon,
        "title": title.${lang},
        "text": text.${lang},
        link
      },
      pagination{
        prevLink,
        nextLink
      }
    }
  }[0]`;

  try {
    const data = await client.fetch(query);
    return data.servicesPage;
  } catch (error) {
    console.error('Error fetching services page:', error);
    return null;
  }
};


export const fetchListSectionData = async () => {
  const query = `
  *[_type == "Tourisme"][0]{
    "listSection": listSection{
      sectionList[]{
      "title": title.${lang},
      "image": image.asset->url,
      "description": description.${lang},
      "position": position
    }
    }
  }
  `;
  try {
    const data = await client.fetch(query);
    console.log(data.listSection.sectionList)
    return data.listSection.sectionList || [];
  } catch (error) {
    console.error('Error fetching list section data:', error);
    return [];
  }
}